/**
 * +----------------------------------------------------------------------
 * | 公共配置
 * +----------------------------------------------------------------------
 * | Author: ant <347302471@qq.com>
 * +----------------------------------------------------------------------
 */

// URL 根地址，这里读取的的是 .evn 文件中的内容，分为生产环境和正式环境
const BASE_URL = process.env.REACT_APP_URL

export { BASE_URL }